import {
  collection,
  query,
  getFirestore,
  getDocs,
  doc,
  setDoc,
  where,
  orderBy,
  limit
} from "firebase/firestore";
import { userUserStore } from "../stores/user";

import { utilFechaConvertirNumeroString } from "../utils/fechaFixedTypes";
import {
  TipoRegistroTurno,
  RegistroTurno,
  registroTurnoConverter
} from "@fixeduy/restaurantestypes";
import { obtenerUltimoRegistroTurno } from "./cloudFunctions/obtenerUltimoRegistroTurno";

export const useRegistrosTurnoStore = {
  async crearRegistro(
    usuarioId: string,
    usuarioNombre: string,
    tipo: TipoRegistroTurno
  ): Promise<RegistroTurno> {
    const db = getFirestore();
    const userStore = userUserStore();
    const empresaId = userStore.empresa?.id;
    if (!empresaId) throw new Error("No hay empresa seleccionada");

    const timestamp = Date.now();
    const timestampString = utilFechaConvertirNumeroString(
      timestamp,
      true,
      "/"
    );

    const registro: Omit<RegistroTurno, "id"> = {
      usuarioId,
      usuarioNombre,
      tipo,
      timestamp: Math.floor(timestamp / 1000),
      timestampString,
      empresaId
    };

    const col = collection(db, `empresas/${empresaId}/registros-turno`);
    const docRef = doc(col);

    const registroCompleto: RegistroTurno = {
      ...registro,
      id: docRef.id
    };

    await setDoc(docRef, registroCompleto);
    return registroCompleto;
  },

  async obtenerUltimoRegistroTurno(
    usuarioId: string
  ): Promise<RegistroTurno | null> {
    const userStore = userUserStore();
    const empresaId = userStore.empresa?.id;
    if (!empresaId) return null;

    return obtenerUltimoRegistroTurno({
      usuarioId,
      idEmpresa: empresaId
    });
  },

  async getRegistrosPorRango(
    fechaInicio: number,
    fechaFin: number,
    usuarioId?: string
  ): Promise<RegistroTurno[]> {
    const db = getFirestore();
    const userStore = userUserStore();
    const empresaId = userStore.empresa?.id;
    if (!empresaId) return [];

    const inicioSec = Math.floor(fechaInicio / 1000);
    const finSec = Math.floor(fechaFin / 1000);

    const col = collection(db, `empresas/${empresaId}/registros-turno`);

    const constraints = [
      where("timestamp", ">=", inicioSec),
      where("timestamp", "<=", finSec),
      orderBy("timestamp", "desc")
    ];

    if (usuarioId) {
      constraints.unshift(where("usuarioId", "==", usuarioId));
    }

    const q = query(col, ...constraints).withConverter(registroTurnoConverter);
    const snapshot = await getDocs(q);

    return snapshot.docs.map(d => d.data());
  }
};
